import "./PageHeader.css";
import PropTypes from "prop-types";

const PageHeader = ({ title, description }) => {
  if (!title) return null;

  return (
    <div className="page-header">
      <h1 className="page-title">{title}</h1>
      {description && <p className="page-description">{description}</p>}
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default PageHeader;
